import { render, staticRenderFns } from "./SalaryDetails.vue?vue&type=template&id=7ef25b1a&"
import script from "./SalaryDetails.vue?vue&type=script&lang=js&"
export * from "./SalaryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports